import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalBudgetsService } from "services/ClientPortalBudgetsService";
import { ClientPortalBudgetsModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  ClientBudgets: new ClientPortalBudgetsModel(),
  Loading: false,
};

export const ClientBudgetsTableSlice = createSlice({
  name: "ClientBudgetsTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBudgetsForClient.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getBudgetsForClient.fulfilled, (state, action) => {
        state.ClientBudgets = action.payload;
        state.Loading = false;
      })
      .addCase(getBudgetsForClient.rejected, (state) => {
        state.ClientBudgets = new ClientPortalBudgetsModel();
        state.Loading = false;
      });
  },
});

export const getBudgetsForClient = createAsyncThunk<ClientPortalBudgetsModel, { clientID: string }>(
  "ClientBudgetsTable/getBudgetsForClient",
  async ({ clientID }) => {
    const budgetsService = container.get<IClientPortalBudgetsService>(SERVICE_TYPES.ClientPortalBudgetsService);
    return await budgetsService.getBudgetsForClient(clientID);
  }
);

export const selectClientBudgets = (state: RootState) => {
  return state.clientBudgetsTable.ClientBudgets;
};

export const selectLoadingClientBudgets = (state: RootState) => {
  return state.clientBudgetsTable.Loading;
};

export default ClientBudgetsTableSlice.reducer;
